/** @format */

import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://146.190.11.26:5055",
  baseURL: "https://api.waytern.in",
});

axiosInstance.interceptors.request.use(reqInterceptor, requestError);
axiosInstance.interceptors.response.use(resIntercepor, responseError);

function resIntercepor(response) {
  return response;
}

function responseError(error) {
  return Promise.reject(error);
}

function reqInterceptor(config) {
  return config;
}

function requestError(error) {
  return Promise.reject(error);
}

export default axiosInstance;
